module.exports = __webpack_public_path__ + "img/account.3d92cecb.svg";